//given a set of events and the id of a model, return true if the model is busy

// export const isModelBusy = (events, modelID, eventToExclude) => {
//     let eventsToCheck = [...events];
//     if (eventToExclude && eventToExclude.ID) {
//         eventsToCheck = eventsToCheck.filter((event) => event.ID !== eventToExclude.ID);
//     }
//     return (
//         eventsToCheck.filter((event) => event.ModelID === modelID && !event.Cancel && event.ModelNotAvailable).length >
//         0
//     );
// };

// NEW METHOD WITH AVAILABILITY CALCULATED BY THE BACKEND
export const isModelBusy = (modelavailability, modelID) => {
    const currentModelAvailability = modelavailability.find((modelAv) => modelAv.ModelID === modelID);
    if (currentModelAvailability) {
        return true;
    } else {
        return false;
    }
};
